<template>
    <div class="income-division-row">
        <div class="cover">
            <el-image :src="$utils.coverImg(info.albumCover, 200, 200)" fit="cover">
                <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                </div>
            </el-image>
            <el-button style="margin-top: 20px" v-if="type == 0 && status == 3" @click="onEdit">修改分账</el-button>
        </div>
        <div class="content">
            <div class="album-info">
                <div class="item">
                    <span class="icon blue"></span>
                    <div class="text">
                        <p>歌曲</p>
                        <h5>{{ info.trackName }}</h5>
                    </div>
                </div>
                <div class="item">
                    <span class="icon green"></span>
                    <div class="text">
                        <p>专辑</p>
                        <h5>{{ info.albumName }}</h5>
                    </div>
                </div>
                <div class="item">
                    <span class="icon purple"></span>
                    <div class="text">
                        <p>本人分到份额</p>
                        <h5 v-if="type == 1">{{ (info.toCpRate * 100).toFixed(2) }}%</h5>
                        <h5 v-else>{{ myRatio }}%</h5>
                    </div>
                </div>
            </div>
            <div v-if="type == 0" class="table-info">
                <table>
                    <thead>
                        <tr>
                            <th>真实名字</th>
                            <th>对方手机号</th>
                            <th>结算比例</th>
                            <th>已分金额</th>
                            <th>状态</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in filterList(info.ruleList)" :key="index" :class="{'stop-tr': item.verifyStatus === 5}">
                            <td>{{ item.toCpRealName }}</td>
                            <td>{{ item.toCpPhoneNum }}</td>
                            <td>{{ (item.toCpRate * 100).toFixed(2) }}%</td>
                            <td>{{ `¥${item.cumulativeGainAmount || 0}` }}</td>
                            <td>
                                <span v-if="item.verifyStatus === 0" class="color-info">未通过</span>
                                <span v-if="item.verifyStatus === 1" class="color-base">已通过</span>
                                <span v-if="item.verifyStatus === 2" class="color-base">已签署</span>
                                <span v-if="item.verifyStatus === 3" class="color-success">已生效</span>
                                <span v-if="item.verifyStatus === 4" class="color-base">签署中</span>
                                <span v-if="item.verifyStatus === 5" class="color-stop">已停止</span>
                            </td>
                            <td>
                                <div>
                                    <router-link
                                        :to="`/manage/distribute/detail/1?trackId=${info.trackId}&albumId=${info.albumId}&trackName=${info.trackName}`"
                                        class="underline"
                                        v-if="item.verifyStatus === 0"
                                    >
                                        重新设置
                                    </router-link>
                                    <router-link
                                        :to="$contractRouter(`/manage/contract/distribute/fdd/signContract??ruleId=${item.ruleId}`, 'url')"
                                        class="underline"
                                        v-if="item.verifyStatus === 1 || item.verifyStatus === 4"
                                    >
                                        去签署
                                    </router-link>
                                    <router-link
                                        :to="`/manage/distribute/detail/3?ruleId=${item.ruleId}`"
                                        class="underline"
                                        v-if="item.verifyStatus === 2"
                                    >
                                        查看
                                    </router-link>
                                    <router-link
                                        :to="`/manage/contractauthorizationdetail?url=${encodeURIComponent(getFpdUrl(item.contractPath))}`"
                                        class="underline"
                                        v-if="item.verifyStatus === 3"
                                    >
                                        查看合约
                                    </router-link>
                                    <div v-if="[1, 4].includes(item.verifyStatus)" class="underline" @click="handleCancel(item.ruleId)">取消分成</div>
                                    <div v-if="item.verifyStatus === 3" class="underline" @click="handleStop(item)">停止分成</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="type == 1" class="table-info">
                <table>
                    <thead>
                        <tr>
                            <th>累计收益金额</th>
                            <th>状态</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ `¥ ${info.cumulativeGainAmount || 0}` }}</td>
                            <td>
                                <span v-if="info.verifyStatus === 3" class="color-success">分成中</span>
                                <span v-if="info.verifyStatus === 5" class="color-info">分成停止</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- 取消分成 -->
        <el-dialog title="取消分成" append-to-body :visible.sync="cancelDialogVisible" width="450px" center>
            <div class="cancelDialog-body">
                <p>是否取消分成，不再签署合同？</p>
            </div>
            <span slot="footer" class="cancelDialog-footer">
                <el-button @click="cancelDialogVisible = false">我再想想</el-button>
                <el-button type="primary" @click="submitCancel">确认取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {cpSplitRuleCancel} from '@/api/distribute';
export default {
    props: {
        info: {
            type: Object,
            default: () => null,
        },
        type: {
            type: Number,
            default: 0, // 0 发起  1 分账
        },
    },
    data() {
        return {
            cancelDialogVisible: false,
            ruleId: '',
        };
    },
    computed: {
        myRatio() {
            const {ruleList} = this.info;
            if (!ruleList) return 100;
            const minusRatio = this.filterList(ruleList)
                ?.filter((item) => item.verifyStatus !== 5)
                ?.reduce((prev, curr) => prev - curr.toCpRate, 1);
            return Number((minusRatio * 100).toFixed(2));
        },
        myself() {
            const {name, telephone} = this.$store.state.userInfo;
            return {name, telephone};
        },
        status() {
            const {ruleList} = this.info;
            let statusSet = new Set(this.filterList(ruleList).map((obj) => obj.verifyStatus));
            if (statusSet.has(0)) {
                return 0;
            } else if (statusSet.has(1)) {
                return 1;
            } else if (statusSet.has(4)) {
                return 1;
            } else if (statusSet.has(2)) {
                return 2;
            } else {
                return 3;
            }
        },
    },
    methods: {
        getFpdUrl(url) {
            const fileUrl = this.$store.state.config && this.$store.state.config.fileUrl;
            return fileUrl + url;
        },
        filterList(list = []) {
            return list.filter((item) => item.toCpRealName !== '自己');
        },
        onEdit() {
            const {trackId, albumId, trackName} = this.info;
            this.$router.push(`/manage/distribute/detail/1?trackId=${trackId}&albumId=${albumId}&trackName=${trackName}`);
        },
        //取消分成
        handleCancel(ruleId) {
            this.ruleId = ruleId;
            this.cancelDialogVisible = true;
        },
        //确认取消
        async submitCancel() {
            try {
                const formData = new FormData();
                formData.append('ruleId', this.ruleId);
                const res = await cpSplitRuleCancel(formData);
                const {state, msg} = res.data;
                if (!state) return this.$message.error(msg || '取消分成失败');
                this.$message.success('取消分成成功');
            } catch (error) {
                this.cancelDialogVisible = false;
                this.$message.error('取消分成失败');
            } finally {
                this.cancelDialogVisible = false;
                this.$emit('freshFunc');
            }
        },
        //停止分成
        handleStop(item) {
            const {trackName, albumName} = this.info;
            const {toCpRealName, ruleId} = item;
            const rate = (item.toCpRate * 100).toFixed(2);
            this.$router.push(
                `/manage/distribute/stop?trackName=${trackName}&albumName=${albumName}&toCpRealName=${toCpRealName}&rate=${rate}&ruleId=${ruleId}&type=${this.type}`
            );
        },
    },
};
</script>
<style lang="scss">
.income-division-row {
    display: flex;
    background-color: $--color-white;
    padding: 40px;
    border-radius: 10px;
    min-height: 275px;

    .cover {
        width: 153px;
        height: 126px;
        position: relative;
        z-index: 10;
        filter: blur(0px);
        margin-right: 60px;

        .el-image {
            border-radius: 6px;
            overflow: hidden;
            background: url('~@/assets/img/upload/bg.png') no-repeat center;
            background-size: cover;
            width: 126px;
            height: 126px;
        }

        &::after {
            content: '';
            background: url('~@/assets/img/album/pic_cd.png') no-repeat center;
            background-size: cover;
            width: 30px;
            height: 108px;
            position: absolute;
            top: 9px;
            right: -3px;
        }
    }

    .content {
        flex: 1;

        .album-info {
            display: flex;
            margin-bottom: 30px;

            .item {
                flex: 1;
                display: flex;
                align-items: center;

                .icon {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-right: 10px;
                    background-repeat: no-repeat;
                    background-size: cover;

                    &.blue {
                        background-image: url('~@/assets/img/distribute/fenz_music.svg');
                    }
                    &.green {
                        background-image: url('~@/assets/img/distribute/fenz_zhuanj.svg');
                    }
                    &.purple {
                        background-image: url('~@/assets/img/distribute/fenz_bai.svg');
                    }
                }

                p {
                    font-size: 12px;
                    color: $-text-500;
                    line-height: 12px;
                }

                h5 {
                    font-size: 16px;
                    color: $-text-950;
                    line-height: 16px;
                    margin-top: 10px;
                }
            }
        }

        .table-info {
            table {
                width: 100%;
            }

            th,
            td {
                font-size: 12px;
                line-height: 12px;
                text-align: left;
            }

            th {
                color: $-text-500;
                padding: 10px 0;
                font-weight: normal;
            }

            td {
                color: $-text-950;
                border-bottom: 1px solid $--color-grey;
                padding: 20px 0;
                font-weight: 600;
            }
            tbody tr td:last-child {
                div {
                    display: inline-block;
                    justify-content: flex-start;
                    .underline {
                        padding-left: 8px;
                        cursor: pointer;
                    }
                }
            }
            tbody .stop-tr {
                td {
                    color: #ddd !important;
                }
            }
        }
    }
}
</style>
